import { AuthDomain } from 'auth-lib-front';
import { DomainV2 } from 'troppus-common/domain';

import Project = AuthDomain.Object.Project;
import ImportTableDefinition = DomainV2.Import.ImportTableDefinition;
import ImportTableDefinitionRevision = DomainV2.Import.ImportTableDefinitionRevision;
import ImportTask = DomainV2.Import.ImportTask;

const listPrefixInner = (projectId: Project.Id) => ['troppus', 'importTask', 'list', projectId] as const;

export const importTaskQueryKeys = {
  /** 指定プロジェクトの list クエリすべてにマッチさせるときに invalidate で使う */
  listPrefix: listPrefixInner,

  list: (
    projectId: Project.Id,
    importTableDefinitionId?: ImportTableDefinition.Id,
    importTableDefinitionRevisionId?: ImportTableDefinitionRevision.Id,
  ) => [...listPrefixInner(projectId), importTableDefinitionId ?? 'all', importTableDefinitionRevisionId ?? 'all'] as const,

  detail: (projectId: Project.Id, id: ImportTask.Id) => ['troppus', 'importTask', 'detail', projectId, id] as const,
};
